import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export type IPiaCopilotRecommendQuestionsParams = {
  context: unknown
  signal?: AbortSignal
}

export type IPiaCopilotRecommendQuestionsRes = {
  questions?: string[]
}

export class PiaApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getCopilotRecommendQuestions(params: IPiaCopilotRecommendQuestionsParams): Promise<IHttpWrap<IPiaCopilotRecommendQuestionsRes>> {
    return this.http({
      method: 'POST',
      url: this.getUrl('ai-service/pia/copilot/recommend'),
      data: {
        context: params.context,
      },
      signal: params.signal,
    })
  }
}
